import React from "react";
import "./AppSidebar.css";
import { SidebarIcon } from "../SidebarIcon/SidebarIcon";
import { Tooltip } from "primereact/tooltip";
import { Divider } from "primereact/divider";
import { IdSeparator } from "../IdSeparator/IdSeparator";

const activeIconColor = "#009eb2";

const nonActiveIconColor = "#777777";

const activeStyle = {
    borderColor: "#00C7CC",
    backgroundColor: "#d8eaec"
};

const nonActiveStyle = {
    borderColor: "transparent"
};

export type NavSidebarItem = {
    text: string;
    logo?: string;
    image?: string;
    id: string;
    to: string;
    callback: (id: string) => void;
};

export enum SeparatorType {
    id
}

export type AppSidebarGroup = {
    id: string;
    groupName: string;
    items: Array<NavSidebarItem>;
    separatorType?: SeparatorType;
};

export type AppSidebarProps = {
    activeItem: string;
    groups: Array<AppSidebarGroup>;
};

const renderNavItems = (
    group: AppSidebarGroup,
    activeItem: string,
    isLastGroup: boolean
) => {
    const groups = group.items.map((item) => {
        const isActive = activeItem === item.to;
        return (
            <>
                <Tooltip target={`#${item.id}`} />
                <li
                    id={item.id}
                    key={item.id}
                    className={`navLink ${isActive ? "active" : ""}`}
                    data-cy={`${item.text}-nav`}
                    onClick={() => item.callback(item.to)}
                    data-pr-tooltip={item.text}
                    data-pr-position="right"
                    data-pr-at="right top+30"
                    data-pr-my="left center-2"
                    style={isActive ? activeStyle : nonActiveStyle}
                >
                    {item.image && (
                        <SidebarIcon
                            src={item.image}
                            fill={
                                isActive ? activeIconColor : nonActiveIconColor
                            }
                            style={"width: 28px; height: 28px"}
                        />
                    )}
                    {item.logo && (
                        <i
                            className={`pi ${item.logo} navLink-icon ${
                                isActive ? "active" : ""
                            }`}
                        />
                    )}
                </li>
            </>
        );
    });

    function renderGroupseparator(separatorType?: SeparatorType) {
        if (separatorType === SeparatorType.id) {
            return <IdSeparator />;
        }

        console.warn(
            `No separator found for sidebar for type ${separatorType}`
        );
        return null;
    }

    return !isLastGroup || group.items.length == 0 ? (
        <>{groups}</>
    ) : (
        <>
            {groups}
            {
                // eslint-disable-next-line no-prototype-builtins
                group.hasOwnProperty("separatorType") ? (
                    renderGroupseparator(group.separatorType)
                ) : (
                    <Divider />
                )
            }
        </>
    );
};

const renderNavGroups = (groups: Array<AppSidebarGroup>, activeItem: string) =>
    groups.map((group, index) =>
        renderNavItems(group, activeItem, groups.length - 1 !== index)
    );

export const AppSidebar = ({ activeItem, groups }: AppSidebarProps) => {
    return (
        <div
            id="app-sidebar"
            className="left-0 top-0 z-1 surface-border surface-section"
            data-cy="app-sidebar"
        >
            <div id="app-sidebar-inner-div" className="flex flex-column h-full">
                <div>
                    <ul className="list-none p-0 m-0">
                        {renderNavGroups(groups, activeItem)}
                    </ul>
                </div>
            </div>
        </div>
    );
};
